//import logger from './logger';

export function percent1080pixel(actual, pixels, type = "height") {
  switch (type) {
      case "width":
          const wPercent = pixels / 1920;
          return wPercent * actual
      case "height":
          const hPercent = pixels / 1080;
          return hPercent * actual
      default:
          window.logger.warning("percent1080p type must be width or height", {});
  }
}

export function bestFitOld(ratio, w_max, h_max) {
  var mxW = { width: w_max, height: w_max / ratio };
  var mxH = { width: h_max * ratio, height: h_max };
  if (mxW.w * mxW.h < mxH.w * mxW.h) {
      return mxW;
  }
  else {
      return mxH;
  }
}

export function bestFit(ratio_w, ratio_h, container_width, container_height) {

  const width_compare = container_width / ratio_w
  const height_compare = container_height / ratio_h

  let width = container_width;
  let height = container_height;

  if (width_compare < height_compare){
      height = width * (ratio_h/ratio_w)
  }
  else{
      width = height * (ratio_w/ratio_h)
  }
  return {width: width, height: height}

}



// WEBPACK FOOTER //
// ./src/utils/screenUtils.js